import React from "react";
import { logAnalyticsEvent } from "../lib/firebase";

const Footer: React.FC = () => {
  const handleSupportLinkClick = (linkType: string) => {
    logAnalyticsEvent("support_link_click", {
      link_type: linkType,
    });
  };

  return (
    <footer className="bg-black-face py-12">
      <div className="container">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">カスタマイズ機能</h3>
            <p className="text-gray-300">
              サイコロの色変更、効果音、お椀のデザインなどのカスタマイズ機能は有料コンテンツとなります。
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-4">その他のアプリ</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.kotaroyamazaki.honkiBaccarat"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-accent transition-colors flex items-center"
                >
                  <span className="mr-2">🎲</span>
                  本気のバカラ
                  <span className="ml-2 text-xs text-gray-400">
                    (Android専用)
                  </span>
                </a>
              </li>
              <li>
                <a
                  href="https://apps.apple.com/us/app/a-simple-dice/id6502541823"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-accent transition-colors flex items-center"
                >
                  <span className="mr-2">🎲</span>
                  Simple Dice
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-4">サポート</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://x.com/honki_chinchiro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-accent transition-colors flex items-center"
                  onClick={() => handleSupportLinkClick("twitter")}
                >
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                  公式Twitter
                </a>
              </li>
              <li>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSc7IKZeyS-KoRz5h6sQ32Or7w5eqZqb2MXH-AwGK6RfzHYQIw/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-accent transition-colors flex items-center"
                  onClick={() => handleSupportLinkClick("contact_form")}
                >
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  お問い合わせ
                </a>
              </li>
              <li>
                <a
                  href="https://six-talk-fed.notion.site/12f0d55eb9984852bdb718f16b827d4d"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-accent transition-colors"
                >
                  プライバシーポリシー
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 text-center text-gray-400">
          <p>&copy; 2024 本気のチンチロ. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
